import lax from 'lax.js';


export function initLax() {

	lax.init();


	lax.addDriver('scrollY', () => window.scrollY, {
		inertiaEnabled: true
	});

	laxAnimations(lax);
}


export function laxAnimations() {
	const animationClasses = [
		'fade-in',
		'fade-up',
		'fade-up-long',
		'fade-down',
		'fade-right',
		'fade-left',
		'fade-up-right',
		'fade-up-left',
		'zoom-in',
		'zoom-in-up'
	];

	const setInitialStyles = (element) => {

		element.style.opacity = '0';
		
		const transformPresets = {
			'fade-in': 'none',
			'fade-up': 'translateY(50px)',
			'fade-up-long': 'translateY(150px)',
			'fade-down': 'translateY(-50px)',
			'fade-right': 'translateX(-50px)',
			'fade-left': 'translateX(50px)',
			'fade-up-right': 'translate(-50px, 50px)',
			'fade-up-left': 'translate(50px, 50px)',
			'zoom-in': 'scale(0.5)',
			'zoom-in-up': 'scale(0.5) translateY(50px)'
		};
		
		for (const [className, transform] of Object.entries(transformPresets)) {
			if (element.classList.contains(className)) {
				element.style.transform = transform;
				break;
			}
		}
	};

	const animateElement = (element) => {
		// Default is no delay
		let delay = 0;
		
		// Check for delay classes
		const delayClass = Array.from(element.classList).find(cls => cls.startsWith('lax-delay-'));
		if (delayClass) {
			const delayValue = delayClass.replace('lax-delay-', '');
			const parsedDelay = parseInt(delayValue, 10);
			if (!isNaN(parsedDelay)) {
				delay = parsedDelay;
			}
		}
		
		setTimeout(() => {
			if (element && element.isConnected) {
				element.style.opacity = '1';
				element.style.transform = 'none';
			}
		}, delay);
	};

	const selector = animationClasses.map(cls => '.' + cls).join(', ');
	const animatedElements = document.querySelectorAll(selector);
	animatedElements.forEach(setInitialStyles);
	
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				animateElement(entry.target);
				observer.unobserve(entry.target);
			}
		});
	}, {
		root: null,
		rootMargin: '0px',
		threshold: 0.15
	});
	
	animatedElements.forEach(element => {
		observer.observe(element);
	});
}